const theme = {
	typography: {
		roundedFontFamily: 'Baloo Bhaijaan, Helvetica, sans-serif',
		fontFamily: 'Helvetica, Arial, sans-serif',
		fontSize: '0.8em',
	},
	colors: {
		primaryColor: 'rgb(98, 188, 68)',
//		primaryColor: 'rgb(2, 35, 60)',
		secondaryColor: 'rgb(0,143,213)',
//		secondaryColor: 'rgb(72,97,121)',
		titleColor: 'white',
		lightGray: '#eff3f6',
	},
	grid: {
	    leftAreaWidth: '300px',
        topAreaHeight: '100px',
        textSearchHeight: '50px',
        topXLargeMargin: '10px',
        topXLargeTextSearchHeight: '42px',
        topXLargeMarginSides: '20px',
		originatorLogoWidth: '46px',
    }
};

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js